/**
 * URL Validation Utilities
 * Validates GCS URLs for security
 */

const ALLOWED_GCS_HOSTS = ['storage.googleapis.com', 'storage.cloud.google.com'];

/**
 * Validate that a URL is a safe GCS HTTPS URL
 *
 * @param url - URL to validate
 * @returns true if URL is valid GCS HTTPS URL
 */
export const isValidGcsUrl = (url: string | null | undefined): boolean => {
  if (!url) return false;

  try {
    const parsed = new URL(url);

    // Must be HTTPS
    if (parsed.protocol !== 'https:') {
      console.warn('[URLValidation] Non-HTTPS URL rejected', { url });
      return false;
    }

    // Must be GCS domain
    if (!ALLOWED_GCS_HOSTS.includes(parsed.hostname)) {
      console.warn('[URLValidation] Non-GCS host rejected', {
        url,
        hostname: parsed.hostname,
        allowed: ALLOWED_GCS_HOSTS,
      });
      return false;
    }

    return true;
  } catch (error) {
    console.warn('[URLValidation] Invalid URL format', { url, error });
    return false;
  }
};

/**
 * Safely get a validated GCS URL or null
 *
 * @param url - URL to validate
 * @returns The URL if valid, null otherwise
 */
export const getValidatedGcsUrl = (
  url: string | null | undefined
): string | null => {
  return isValidGcsUrl(url) ? url! : null;
};
